// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__9xk2X","inputWrap":"Table_inputWrap__2IGmB","col":"Table_col__3zcHK","bmiTooltip":"Table_bmiTooltip__3O3h-"};